module.exports = __webpack_public_path__ + "img/9788957983799.73e2fdbc.jpg";